import React, { useState } from 'react';
import { Platform, Pressable, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import Button from '@/components/Buttons/Button';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';

export default function TasksIntro({ title, subtitle, onCreate }) {
  const { colors, theme } = useTheme();
  const { t } = useTranslation();
  const { isXS, isSM } = useResponsiveness();
  const compact = isXS || isSM;
  const palette = getCatalogPalette(theme);
  const [expanded, setExpanded] = useState(false);

  return (
    <View style={{ paddingHorizontal: isXS ? 16 : 24, paddingTop: compact ? 20 : 28, paddingBottom: 28, gap: 16 }}>
      <View style={{ flexDirection: compact ? 'column' : 'row', alignItems: compact ? 'stretch' : 'center', gap: 16 }}>
        <View style={{ flex: compact ? undefined : 1, minWidth: 0, gap: 8 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 14 }}>
            <Text tag="h1" weight="bold" style={{ fontSize: 32, lineHeight: 38, letterSpacing: -0.8 }}>{title}</Text>
            <Pressable accessibilityRole="button" accessibilityLabel={t('pages.tasks.aboutTasks')}
              accessibilityState={{ expanded }}
              {...(Platform.OS === 'web' ? { 'aria-expanded': expanded } : {})}
              onPress={() => setExpanded(value => !value)}
              style={({ hovered, pressed }) => [{ flexDirection: 'row', alignItems: 'center', gap: 6, padding: 8, borderRadius: 8 }, (hovered || pressed || expanded) && { backgroundColor: palette.hover }]}>
              <Icon name="circle-info" size={13} color={colors.text_color_secondary} />
            </Pressable>
          </View>
          <Text tag="p" color="secondary" style={{ fontSize: 14, lineHeight: 21, maxWidth: 640 }}>{subtitle}</Text>
        </View>
        <Button text={t('pages.tasks.newTask')} prependIcon="plus" variant="secondary" size="medium" textWeight="semibold"
          onPress={onCreate} style={{ alignSelf: 'flex-start', backgroundColor: palette.ink, borderRadius: 10 }}
          textStyle={{ color: palette.onInk }} iconColor={palette.onInk} hoverBackgroundColor={palette.ink} />
      </View>
      {expanded && (
        <View style={{ padding: 16, borderWidth: 1, borderColor: palette.border, backgroundColor: palette.surface, borderRadius: 14 }}>
          <Text size="s" color="secondary" style={{ lineHeight: 21 }}>{t('pages.tasks.aboutTasksDescription')}</Text>
        </View>
      )}
    </View>
  );
}
